import { getUUID } from "utils/uuid";

export const getValidationRequestDefault = () => ({
  enabled: true,
  triggers: ["onChange"],
  actions: null,
  integration_id: "",
  validation: {
    conditions: [
      /**
       * Conditions
       * - a collection of checks to make against the response object
       * - response.isSubscribed isEqual false
       * {
       *  integration_id: "abc",
       *  key: "isSubscribed",
       *  operator: "isTrue",
       *  value: "true"
       * }
       */
      {
        uuid: getUUID(),
        key: "",
        operator: "",
        value: ""
      }
    ]
  }
});
